import { setAttr, mount } from 'redom';

import internalEventCodes from 'event-system/codes/internal';

import Assistant from 'root/startup-view/assistant';

import serverInterface from 'server-interface';

class AssistantManager {

  constructor(application) {

    this.application = application;
    this.ready = true;
    this.assistant = null;
    this.data = null;
    this.assistantWindow = null;
    this.spinnerDialog = null;
    this.text = '';
    this.container = document.getElementById('root-assistant-container');
    this.assistant = new Assistant();

    setAttr(this.container, {
      onclick: this.tryHide.bind(this)
    });

  }

  tryHide(event) {

    if (event.target !== document.getElementById('root-assistant-content')) {
      return;
    }

    this.hide();

  }

  async loadAssistantData(bootstrapData = {}) {

    this.data = bootstrapData.assistant || await serverInterface.startup.assistants.getAssistantByStartupId();

    this.assistant.data = this.data;
    this.assistant.setConversation(bootstrapData.assistantConversation);

  }

  async getAssistantData() {

    return this.data;

  }

  async initialize() {

    mount(document.getElementById('assistant-container'), this.assistant);

    this.assistant.initialize();
    this.assistant.onShow();

  }

  async copyMessageToClipboard(message) {

    await navigator.clipboard.writeText(message.text);

    this.application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message: 'Message copied to clipboard',
      seconds: 5,
      type: 'info'
    });

  }

  setText(text = '') {

    this.assistant.setText(text);

  }

  setContent(content) {

    this.assistant.setContent(content);

  }

  show() {

    this.assistant.setText('');

    // return this.application.dialogsManager.showLiveComponent('assistant').then(onResult);

  }

  hide() {

    // this.application.dialogsManager.hideLiveComponent('assistant');

  }

}

export default AssistantManager;